/** @jsx jsx */

import { useRef } from 'react';
import { css, jsx } from '@emotion/core';
import { Text } from '@chameleoncreator/creator-ui';
import 'services/ie11closestPolyfill';
import bulletStyles from './bulletStyles';

const ReadOnlyText = ({
  content,
  className,
  useBackgroundControls,
  borderRadius,
  backgroundColor,
  bulletColor,
  liTextColor,
}) => {
  //
  const readOnlyText = useRef(null);

  return (
    <Text
      ref={readOnlyText}
      className={`chameleon-text${className ? ` ${className}` : ''}`}
      as="div"
      css={css`
        ${bulletStyles(bulletColor, liTextColor)}
      `}
      style={{
        ...((useBackgroundControls || backgroundColor) && {
          borderRadius,
          background: backgroundColor,
          padding: borderRadius * 3,
        }),
      }}
    >
      <div
        dangerouslySetInnerHTML={{
          __html: content,
        }}
      />
    </Text>
  );
};

export default ReadOnlyText;
